var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfantWhite(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.99408 11.9922H9.00408",
    stroke: "white",
    strokeWidth: 1.99868,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9901 11.9922H15.0001",
    stroke: "white",
    strokeWidth: 1.99868,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99342 15.9895C10.4931 16.2893 11.1926 16.4892 11.9921 16.4892C12.7916 16.4892 13.4911 16.2893 13.9908 15.9895",
    stroke: "white",
    strokeWidth: 1.99868,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9875 6.29587C19.8929 7.4308 20.51 8.76802 20.7863 10.1933C21.1242 10.357 21.4092 10.6125 21.6086 10.9306C21.808 11.2488 21.9138 11.6167 21.9138 11.9921C21.9138 12.3676 21.808 12.7355 21.6086 13.0536C21.4092 13.3717 21.1242 13.6273 20.7863 13.7909C20.3549 15.8031 19.2465 17.6064 17.6461 18.9001C16.0456 20.1938 14.05 20.8995 11.9921 20.8995C9.93421 20.8995 7.93856 20.1938 6.33814 18.9001C4.73771 17.6064 3.62932 15.8031 3.19789 13.7909C2.85997 13.6273 2.57499 13.3717 2.37558 13.0536C2.17618 12.7355 2.07042 12.3676 2.07042 11.9921C2.07042 11.6167 2.17618 11.2488 2.37558 10.9306C2.57499 10.6125 2.85997 10.357 3.19789 10.1933C3.61188 8.16515 4.71279 6.34186 6.31487 5.03107C7.91694 3.72028 9.92212 3.00223 11.9921 2.99805C13.9908 2.99805 15.4898 4.09732 15.4898 5.4964C15.4898 6.89548 14.5904 7.99476 13.4911 7.99476C12.6916 7.99476 11.9921 7.59502 11.9921 6.99541",
    stroke: "white",
    strokeWidth: 1.99868,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfantWhite);
export default __webpack_public_path__ + "static/media/infantWhite.0bc4f494a469bfbca3f6dcbff94a079f.svg";
export { ForwardRef as ReactComponent };